export enum IconType {
  IC_16_COPY = 'ic_16_copy',
  IC_18_CALENDAR = 'ic_18_calendar',
  IC_18_CALENDAR_PRESS = 'ic_18_calendar_press',
  IC_18_DOWN = 'ic_18_down',
  IC_18_DOWN_PRESS = 'ic_18_down_press',
  IC_18_FILTER = 'ic_18_filter',
  IC_18_FILTER_PRESS = 'ic_18_filter_press',
  IC_18_HISTORY = 'ic_18_history',
  IC_18_LOCATION = 'ic_18_location',
  IC_18_LOCATION_PRESS = 'ic_18_location_press',
  IC_18_ON_DELETE = 'ic_18_on_delete',
  IC_18_REFRESH = 'ic_18_refresh',
  IC_18_REPORT = 'ic_18_report',
  IC_18_SEARCH = 'ic_18_search',
  IC_18_SEARCH_PRESS = 'ic_18_search_press',
  IC_24_ALL = 'ic_24_all',
  IC_24_AVATAR = 'ic_24_avatar',
  IC_24_BATTERY_LOCK = 'ic_24_battery_lock',
  IC_24_BATTERY_NOR = 'ic_24_battery_nor',
  IC_24_BATTERYFULL = 'ic_24_batteryfull',
  IC_24_BIKECODE_NOR = 'ic_24_bikecode_nor',
  IC_24_BIKECODE_PRESS = 'ic_24_bikecode_press',
  IC_24_CAMERA = 'ic_24_camera',
  IC_24_CAMERA_DISABLE = 'ic_24_camera_disable',
  IC_24_CHECK = 'ic_24_check',
  IC_24_CHECK_PRESS = 'ic_24_check_press',
  IC_24_CHECK_SMALL = 'ic_24_check-small',
  IC_24_CHECKBOX = 'ic_24_checkbox',
  IC_24_CLOSE = 'ic_24_close',
  IC_24_CLOSE_2 = 'ic_24_close_2',
  IC_24_CLOSE_SMALL = 'ic_24_close-small',
  IC_24_CLOSE_SMALL_WHITE = 'ic_24_close_small_white',
  IC_24_DESTINATION = 'ic_24_destination',
  IC_24_FILTER = 'ic_24_filter',
  IC_24_FLASH_NOR = 'ic_24_flash_nor',
  IC_24_FLASH_PRESS = 'ic_24_flash_press',
  IC_24_HOME = 'ic_24_home',
  IC_24_HOME_PRESS = 'ic_24_home_press',
  IC_24_LEFT = 'ic_24_left',
  IC_24_LEFT_SMALL = 'ic_24_left-small',
  IC_24_LIST = 'ic_24_list',
  IC_24_LIST_PRESS = 'ic_24_list_press',
  IC_24_LOCATION = 'ic_24_location',
  IC_24_LOWBATTERY = 'ic_24_lowbattery',
  IC_24_MAP = 'ic_24_map',
  IC_24_MAP_SMALL_GRAY = 'ic_24_map_small_gray',
  IC_24_MY__PRESS = 'ic_24_my__press',
  IC_24_NAVI = 'ic_24_navi',
  IC_24_NOBATTERY = 'ic_24_nobattery',
  IC_24_NOTFOUND = 'ic_24_notfound',
  IC_24_PLACE = 'ic_24_place',
  IC_24_PLUS = 'ic_24_plus',
  IC_24_PLUS_SMALL = 'ic_24_plus-small',
  IC_24_QR = 'ic_24_QR',
  IC_24_QR_PRESS = 'ic_24_QR_press',
  IC_24_REPAIR = 'ic_24_repair',
  IC_24_REPORT = 'ic_24_report',
  IC_24_SEARCH = 'ic_24_search',
  IC_24_SEARCH_PRESS = 'ic_24_search_press',
  IC_24_SEARCH_SMALL = 'ic_24_search_small',
  IC_24_SEARCH_SMALL_PRESS = 'ic_24_search_small_press',
  IC_24_SOUNDS = 'ic_24_sounds',
  IC_24_SOUNDS_DIM = 'ic_24_sounds_dim',
  IC_24_TOOL = 'ic_24_tool',
  IC_24_TROUBLE_RED = 'ic_24_trouble_red',
  IC_24_TRUCK = 'ic_24_truck',
  IC_24_TRUCK_FRONT = 'ic_24_truck_front',
  IC_24_UNCHECK = 'ic_24_uncheck',
  IC_24_UNDO = 'ic_24_undo',
  IC_24_USER = 'ic_24_user',
  IC_24_SCALE = 'ic_24_scale',
  IC_24_SCALE_PRESS = 'ic_24_scale_press',
  IC_48_HOME_PRESS = 'ic_48_home_press',
  IC_48_LIST_PRESS = 'ic_48_list_press',
  IC_48_QR_PRESS = 'ic_48_qr_press',
  IC_48_SEARCH_PRESS = 'ic_48_search_press',
  IC_48_USER_PRESS = 'ic_48_user_press',
}
